import Config from 'config/settings';
import { device } from 'utils/device';
import ProjectHeaderSizes from 'app/views/project/ProjectHeaderSizes';

export default class WorkCarouselSizes {
	public static widthMuliplier(): number {


		if (device.isPortraitDevice) {
			return 1.3;
		}

		return 0.93;
	}

	public static tileSize(): any {
		if (device.isPortraitDevice) {
			return {
				width:
					device.innerWidth < Config.mobileBreakpoint
						? device.innerWidth - 40
						: device.innerWidth - 100,
				height: ProjectHeaderSizes.heightFromMobileDesign(202)
			};
		}

		if (device.innerWidth < 500) {
			return {
				width: device.innerWidth - 40,
				height: Math.min(350, device.innerHeight * 0.37)
			};
		}
		if (device.innerWidth < 1000) {
		}

		let idealWidth = 1280;
		let idealHeight = 540;

		let maxHeightPercentage = 0.47;
		let maxWidthPercentage = 0.68;

		let ow = idealWidth / device.innerWidth > maxWidthPercentage;
		let oh = idealHeight / device.innerHeight > maxHeightPercentage;
		let w = idealWidth;
		let h = idealHeight;

		if (ow || oh) {
			var maxWidth = device.innerWidth * maxWidthPercentage;
			var maxHeight = device.innerHeight * maxHeightPercentage;

			var ratio = Math.min(maxWidth / idealWidth, maxHeight / idealHeight);
			w = idealWidth * ratio;
			h = idealHeight * ratio;

		} else {
			h = idealHeight;
			w = idealWidth;
		}

		//Default desktop:
		return {
			width: w,
			height: h
		};
	}
}
